<template>
  <div>
    <vue-headful :title="title" />
    <detail-field-2>
      <template v-slot:label>Description</template>
      <template v-slot:value>{{ subscription?.description || '-' }}</template>
    </detail-field-2>
    <detail-field-2>
      <template v-slot:label>Product Code</template>
      <template v-slot:value>{{ subscription?.productCode || '-' }}</template>
    </detail-field-2>
    <detail-field-2>
      <template v-slot:label>Owning Account</template>
      <template v-slot:value>{{ getAccountNameFromId(subscription?.accountId) }}</template>
    </detail-field-2>
    <detail-field-2>
      <template v-slot:label>Start Date</template>
      <template v-slot:value>{{ format(addMinutes(new Date(subscription?.startDate), new Date(subscription?.startDate).getTimezoneOffset()), 'yyyy-MM-dd') }} (UTC)</template>
    </detail-field-2>
    <detail-field-2>
      <template v-slot:label>End Date</template>
      <template v-slot:value>{{ format(addMinutes(new Date(subscription?.endDate), new Date(subscription?.endDate).getTimezoneOffset()), 'yyyy-MM-dd') }} (UTC)</template>
    </detail-field-2>
    <detail-field-2>
      <template v-slot:label>Data Package</template>
      <template v-slot:value>{{ subscription?.dataLimitInGb }} GB</template>
    </detail-field-2>
    <template v-if="$hasRole('Super User,Kymeta Admin,Sales Support')">
      <detail-field-2>
        <template v-slot:label>Salesforce Id</template>
        <template v-slot:value>{{ subscription?.salesforceObjectId }}</template>
      </detail-field-2>
      <detail-field-2>
        <template v-slot:label>Salesforce Account Id</template>
        <template v-slot:value>{{ subscription?.salesforceAccountId }}</template>
      </detail-field-2>
      <detail-field-2>
        <template v-slot:label>Salesforce Sub Number</template>
        <template v-slot:value>{{ subscription?.subscriptionNumber }}</template>
      </detail-field-2>
    </template>
    <template v-if="$hasRole('Super User,Kymeta Admin')">
      <detail-field-2>
        <template v-slot:label>Networks</template>
        <template v-slot:value>{{ subscription?.networkIdentifiers?.join(', ') }}</template>
      </detail-field-2>
    </template>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { format, addMinutes } from 'date-fns';
import { useSubscriptions2Store } from '../subscriptions2-store';
import getAccountNameFromId from '../../utilities/getAccountNameFromId';

const store = useSubscriptions2Store();

const subscription = computed(() => store.state.subscription);
const title = computed(() => `${subscription.value?.description} / Overview`);
</script>
